<template>
  <b-card style="background-color: rgb(255, 127, 96, 0.0);">
    <b-row>
      <b-col
        lg="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 740 426"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M682.009 424.358H682.01H739.5V397.448V370.038V216.426V62.815V27.7933L715.772 0.5H0.5V27.4102V54.8204V367.753V401.793L24.2068 425.5L682.009 424.358Z"
            stroke="#00B058"
          />
          <path
            d="M54 424H24.6821L2 401V375"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M686 2H715.318L738 25V51"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            width="100%"
            height="100%"
            y="20"
            x="-30"
          >
            <span style="color:#ffffff;font-size:24px; margin-left:50px">สัดส่วนการติดตั้งป้าย VMS ทุกสายทาง</span>
            <div class="pie-text text-center">
              <h3 class="font-weight-bold">โดยรวม</h3>
              <h2 class="font-weight-bolder">
                {{ camTotal }}
              </h2>
            </div>

            <div class="chart">
              <app-echart-doughnut :series="series" />
            </div>
            <div class="pie-text1 text-center">
              <div
                v-for="(data,index) in series[0].data"
                :key="index"
                class="d-flex justify-content-between"
              >
                <div class="series-info">
                  <feather-icon
                    :icon="data.icon"
                    size="16"
                    class="mr-50"
                    :style="{color: data.iconColor, fill:data.iconColor}"
                  />
                  <span>{{ data.name }}</span>
                </div>
                <span style="color:#ffffff;">{{ data.VMS_count }}</span>
              </div>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 428"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M681.088 426.353H681.089H738.5V399.314V371.775V217.442V63.1099V24.2414L708.611 0.5H0.5V27.5389V55.0777V369.48V403.265L29.7649 427.5L681.088 426.353Z"
            stroke="#00B058"
          />
          <path
            d="M54 426H24.6821L2 403V377"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 25V51"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            width="95%"
            height="100%"
            x="20"
          >
            <br>
            <span style="color:#ffffff;font-size:24px; margin-left:10px">5 Top จุดติดตั้งป้าย VMS สูงสุด </span>
            <b-row
              v-for="(item, index) in progress"
              :key="index"
              style="margin-top:10px"
              class="mt-2"
            >
              <b-col
                lg="10"
              >
                <label style="color: #ffffff; font-size: 18px;">{{ index+1 +'. ' }} {{ item.WayID }}</label>
                <b-progress
                  :value="item.Location_VMS"
                  :max="progress[0].Location_VMS + 5"
                  precision="2"
                  class="progress8"
                />
              </b-col>
              <b-col
                lg="2"
                style="text-align: left;"
              >
                <br>
                <span style="color:#ffffff; ">{{ item.Location_VMS }} จุด</span>
              </b-col>
            </b-row>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BProgress, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartDoughnut from './AppEchartDoughnut.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartDoughnut,
    BProgress,
    BCard,
  },
  data() {
    return {
      progress: [],
      camTotal: '',
      series: [
        {
          color: ['#579BFE', '#DC48FF', '#8246FE', '#FE447A', '#4EAF51', '#FF805D', '#FDFF01'],
          name: 'Visit source',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getSumCCTV()
    this.getPieData()
    this.getTop5()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getSumCCTV()
      this.getPieData()
      this.getTop5()
    }, 300000)
  },
  methods: {
    getSumCCTV() {
      axios
        .post('/getSumCCTVTotal', { department: this.userData.department })
        .then(response => {
          this.total = response.data[0].Total
          this.online = response.data[0].Online
          this.offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPieData() {
      axios
        .post('/getPercentVMSTotal', { department: this.userData.department })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.series[0].data = response.data[0]
          // eslint-disable-next-line prefer-destructuring
          this.camTotal = response.data[1][0].Total_VMS
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTop5() {
      axios
        .post('/getTop5TotalVMS', { department: this.userData.department })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">

  .chart{
    top: 0;
    left: 0;
    right: 60px;
  }
  .pie-text{
    width: 105px;
    position:absolute;
    margin: auto;
    left: 0;
    right: 19%;
    top: 45%;
    bottom: 0;
  }
  .pie-text1{
    width: 200px;
    position:absolute;
    margin: auto;
    left: 70%;
    right: 0;
    top: 40%;
    bottom: 0;
  }
  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
